import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import UserBadge from './UserBadge';
import './style-new.css';

const ViewTeams = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');

  const [game, setGame] = useState(null);
  const [teams, setTeams] = useState([]);
  const [teamsExist, setTeamsExist] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authToken) { navigate('/login'); return; }

    const fetchData = async () => {
      try {
        const [gameRes, teamsRes] = await Promise.all([
          fetch(`/api/games/${gameId}`, { headers: { Authorization: `Bearer ${authToken}` } }),
          fetch(`/api/game-teams/${gameId}`, { headers: { Authorization: `Bearer ${authToken}` } })
        ]);

        if (!gameRes.ok || !teamsRes.ok) throw new Error('Failed to fetch data');

        const gameData = await gameRes.json();
        const teamsData = await teamsRes.json();

        setGame(gameData.game || gameData);

        if (teamsData.teamsExist) {
          setTeamsExist(true);
          setTeams(teamsData.teams);
        }
      } catch (err) {
        console.error(err);
        alert('Could not load teams');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [gameId, authToken]);

  if (loading) return <div style={styles.loading}>Loading teams...</div>;

  const teamColors = ['#5b9bd5', '#e06c6c', '#6cc47e', '#f0a500', '#9b59b6', '#1abc9c'];

  return (
    <div className="page-container">
      <UserBadge />
      <div className="center-content">
        <h2>Teams</h2>
        {game && <p style={{ color: '#555', marginBottom: '20px' }}>{game.description}</p>}

        {!teamsExist ? (
          <p style={{ color: '#888' }}>No teams have been created yet for this game.</p>
        ) : (
          <div style={styles.teamsContainer}>
            {teams.map((team, index) => {
              const color = teamColors[index % teamColors.length];
              return (
                <div key={index} style={{ ...styles.teamCard, borderTop: `4px solid ${color}` }}>
                  <h4 style={{ ...styles.teamHeader, color }}>{team.name}</h4>
                  <ol style={styles.playerList}>
                    {team.players.map(p => (
                      <li key={p.user_id} style={styles.playerItem}>
                        {p.name} {p.surname}
                      </li>
                    ))}
                  </ol>
                  <p style={styles.count}>{team.players.length} player{team.players.length !== 1 ? 's' : ''}</p>
                </div>
              );
            })}
          </div>
        )}

        <div className="button-group" style={{ marginTop: '24px' }}>
          <button className="btn btn-grey" onClick={() => navigate(-1)}>⬅ Back</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  loading: { padding: '20px', textAlign: 'center' },
  teamsContainer: { display: 'flex', flexWrap: 'wrap', gap: '16px' },
  teamCard: {
    flex: '1 1 200px',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '16px',
    minWidth: '180px'
  },
  teamHeader: { margin: '0 0 12px 0', fontSize: '1.1em' },
  playerList: { paddingLeft: '20px', margin: '0 0 8px 0' },
  playerItem: { padding: '4px 0', fontSize: '0.95em', borderBottom: '1px solid #eee' },
  count: { fontSize: '0.8em', color: '#aaa', margin: '8px 0 0 0' }
};

export default ViewTeams;
